import { createWithEqualityFn as create } from 'zustand/traditional'
import { shallow } from 'zustand/vanilla/shallow'

import { createSelectors } from '@/shared/lib/createSelectors.ts'

import { LIKES_AMOUNT_TO_SHOW_POPUP } from './constants/likesAmountToShowPopup'
import { SessionLikesAction, SessionLikesState } from './sessionLikesTypes'

export const useSessionLikesStoreBase = create<
	SessionLikesState & SessionLikesAction
>(
	set => ({
		currentSessionAmount: 0,
		isPopupShown: false,
		increment: () => {
			set(state => {
				const newCurrentAmount = state.currentSessionAmount + 1
				let showPopup = false
				if (newCurrentAmount === LIKES_AMOUNT_TO_SHOW_POPUP) {
					showPopup = true
				}
				return {
					...state,
					currentSessionAmount: newCurrentAmount,
					isPopupShown: showPopup
				}
			})
		},
		decrement: () => {
			set(state => {
				const newCurrentAmount = Math.max(0, state.currentSessionAmount - 1)
				return {
					...state,
					currentSessionAmount: newCurrentAmount
				}
			})
		},
		reset: () => {
			set(state => {
				return {
					...state,
					isPopupShown: false,
					currentSessionAmount: 0
				}
			})
		}
	}),
	shallow
)

export const useSessionLikesStore = createSelectors(useSessionLikesStoreBase)
